import { useTranslation } from 'react-i18next';
import {
  SUPPORTED_LANGUAGES,
  findCurrentSupportedLanguageEntry,
} from '../../i18n';

import './Language.scss';

const LanguageSwitcher = ({ children, context = 'top-level' }) => {
  const { i18n } = useTranslation();
  const info = findCurrentSupportedLanguageEntry();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className={`lang-switcher lang-switcher--${context}`}>
      <div className="inner">
        {SUPPORTED_LANGUAGES.map(
          (lang) =>
            lang.menu && (
              <button
                key={lang.locale}
                className={lang.locale === info.locale ? 'active' : ''}
                onClick={() => changeLanguage(lang.locale)}
              >
                {lang.flag} {lang.locale.toUpperCase()}
              </button>
            )
        )}
      </div>

      {children}
    </div>
  );
};

export default LanguageSwitcher;
